import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

interface UseDeletePublicCompanyLeadSpecialFeeProps {
  publicCompanyLeadId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useDeletePublicCompanyLeadSpecialFee = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseDeletePublicCompanyLeadSpecialFeeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deletePublicCompanyLeadSpecialFee'],
    mutationFn: async (id: string) => {
      const lead = {
        fee_rule_attributes: {
          special_entries_attributes: [
            {
              id,
              _destroy: true,
            },
          ],
        },
      }

      await privateAxios.put(`/funnel/public/leads/${publicCompanyLeadId}`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
